<template>
  <b-row class="mb-4">
    <b-col>
      <b-button
        @click="goTo('ActAlipayCoupons')"
        :variant="currentRoute === 'ActAlipayCoupons' ? 'info' : 'outline-info'"
        class="mr-2 mb-2"
      >
        Platfone Coupons
      </b-button>
      <b-button
        @click="goTo('TnAlipayCoupons')"
        :variant="currentRoute === 'TnAlipayCoupons' ? 'info' : 'outline-info'"
        class="mb-2"
      >
        Temp-Number Coupons
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const currentRoute = computed(() => route.name)

    const goTo = (name) => router.push({ name })

    return { currentRoute, goTo }
  }
}
</script>
